const colors = {
  primary: "rgb(242, 49, 123)",
  secondary: "#FF8D7B",
  tertiary: "rgb(62, 163, 251)",
};

export default colors;
